import { axiosRequest } from "../../configs/axios.config";

export class SkillService {
  getSkills(filters, success, error) {
    axiosRequest
      .post("/skills/search", filters)
      .then(({ data }) => success(data))
      .catch((errorResp) => error(errorResp));
  }
}
